<template>
    <div>
        <div
            class="new-subscriber new-subscriber-confirmation mt-2 mb-2 lightgray-content p-3"
            :key="index"
        >
            <div class="mb-3 text-uppercase h5 lightgray-content py-2">
                <strong class="mb-2 red">{{ teatro.texto_simpatizante }}:</strong>
                {{ membresia.nombre }} {{ membresia.apellidos }}
            </div>

            <div class="row">
                <div class="col-12 col-lg-7">
                    <label class="mb-2">{{ $t('gracias.datos_personales') }}</label>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-user"></i>
                            {{ membresia.nombre }} {{ membresia.apellidos }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-id-card"></i>
                            {{ membresia.dni }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-envelope"></i>
                            {{ membresia.email }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-phone"></i>
                            {{ membresia.telefono }}
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-5 text-md-right mt-3 mt-md-0 pr-0">
                    <div class="d-block">
                        <label>{{ $t('gracias.precio_abono', { abono: teatro.texto_simpatizante }) }}</label>
                        <div class="h3 price mt-0">
                            <span class="h2" v-if="!membresia.descuento_aplicado">
                                {{ formatPrice(membresia.importe_sin_descuento) }}
                            </span>
                            <template v-else>
                                <span class="h2">
                                    {{ formatPrice(membresia.importe) }}
                                </span>
                                <span class="h4">
                                    (<del>{{ formatPrice(membresia.importe_sin_descuento) }}</del>)
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';

    const props = defineProps({
        membresia: {
            required: true,
            type: Object
        },
        index: {
            required: true,
            type: Number
        }
    });

    const teatro = computed(() => store.getters.getTeatro);

    function formatPrice(amount) {
        return new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency: 'EUR'
        }).format(amount || 0);
    }
</script>
